import React, { memo } from 'react';
import { Checkbox, FormControlLabel, Grid } from '@material-ui/core';
import styled from 'styled-components';
import { FieldErrors, UseFormMethods } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';

import { stringConstants } from './common/strings';
import { CustomError } from './common/customError';

interface TermsOfServiceProps  {
    fieldsErrors: FieldErrors;
    register: UseFormMethods['register'];
}

export const TermsOfService = memo(({ register, fieldsErrors }: TermsOfServiceProps) => {
    const { t } = useTranslation();
    const translatedTermsAndConditionsErrorMessage = t('termsAndConditionsErrorMessage');

    return (
        <Grid item xs={12}>
            <StyledFormControlLabel
                id='terms'
                name='terms'
                control={
                    <StyledCheckbox 
                        size='small'
                        inputRef={register({
                            required: translatedTermsAndConditionsErrorMessage
                        })}
                    />
                }
                label={
                    <TermsOfServiceText>
                        <Trans i18nKey='bySelecting'>
                            {stringConstants.bySelecting}
                            <a href={stringConstants.legalTermsLink} target='_blank' rel='noreferrer'>
                                {stringConstants.terms}
                            </a> 
                            {stringConstants.and} 
                            <a href={stringConstants.privacyPolicyLink} target='_blank' rel='noreferrer'>
                                {stringConstants.privacyPolicy}
                            </a>.
                        </Trans>
                    </TermsOfServiceText>
                }
            />
            {fieldsErrors.terms 
                && <CustomError>
                    {fieldsErrors.terms.message}
                </CustomError>
            }
        </Grid>
    );
});

const StyledFormControlLabel = styled(FormControlLabel)`
    margin-top: 31px;
`;

const TermsOfServiceText = styled.span`
    font-size: 13px;
    font-weight: 400;
`;

const StyledCheckbox = styled(Checkbox)`
    padding-top: 0;
    color: #888888 !important;
`;
